import { Cross } from "lucide-react";
import { ArchWindow } from "./ArchWindow";

export const Footer = () => (
  <footer className="border-t border-[#F3A0A0]/10 bg-[#0D050F] py-16" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <ArchWindow size={26} bar="#0D050F" />
            <div className="leading-none">
              <span className="font-orbitron font-black text-white text-lg tracking-widest">DIGITAL</span>
              <span className="block font-orbitron text-[10px] tracking-[0.5em] text-[#F3A0A0]">MISSIONS</span>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#FAD0C4]/50 leading-relaxed max-w-xs">
            I build websites and run outreach for churches around the world, free of charge, so the Gospel can be found by anyone who goes looking for it.
          </p>
          <p className="mt-4 font-orbitron text-xs tracking-widest text-[#E84C4C]">DIGITALMISSIONS.AI</p>
        </div>
        <div>
          <h4 className="font-orbitron text-xs tracking-[0.3em] text-[#F3A0A0] mb-5">EXPLORE</h4>
          <ul className="space-y-3 text-sm text-[#FAD0C4]/60">
            <li><a href="#manifesto" className="hover:text-white transition-colors">Why I Do This</a></li>
            <li><a href="#services" className="hover:text-white transition-colors">What I Build</a></li>
            <li><a href="#portfolio" className="hover:text-white transition-colors">The Work</a></li>
            <li><a href="#verse" className="hover:text-white transition-colors">Verse of the Day</a></li>
            <li><a href="#apply" className="hover:text-white transition-colors">Tell Me About Your Church</a></li>
            <li><a href="#donate" className="hover:text-white transition-colors">Give</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-orbitron text-xs tracking-[0.3em] text-[#F3A0A0] mb-5">THE WORD</h4>
          <blockquote className="italic font-light text-sm text-[#FAD0C4]/70 leading-relaxed">
            "Your word is a lamp to my feet and a light to my path."
          </blockquote>
          <p className="mt-3 font-orbitron text-xs tracking-widest text-[#F3A0A0]/60">PSALM 119:105</p>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-[#F3A0A0]/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#FAD0C4]/40">
        <span>© {new Date().getFullYear()} Digital Missions · A nonprofit ministry by Luke Adams</span>
        <span className="flex items-center gap-2">Same Message. A Brighter Tomorrow. <Cross className="w-3.5 h-3.5 text-[#E84C4C]" fill="currentColor" /></span>
      </div>
    </div>
  </footer>
);
